// --------------------------------------------------------------------------
// #22– Interactive mosaic
// --------------------------------------------------------------------------
// Author:      Sarah Blount
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');
var ModalDisplay = require('./modal');
var modalDisplay = new ModalDisplay();
var debounce = require('../utilities/debounce');

// jquery plugins
require('../plugins/slick');

module.exports = function (options) {
    var context = options.context,
        jqMosaicItem = context.find('.interactive-mosaic-item, .interactive-mosaic-item--large'),
        internalExists = false,
        externalExists = false;
    function init() {

        function callModal() {
            if ($(window).width() > 768) {
                if (!internalExists) {
                    if (externalExists) {
                        externalExists = false;
                        modalDisplay.destroyExternalModal(jqMosaicItem);
                    }
                    internalExists = true;
                    modalDisplay.internalModal(jqMosaicItem);
                }
            } else {
                if (!externalExists) {
                    if (internalExists) {
                        internalExists = false;
                        modalDisplay.destroyInternalModal(jqMosaicItem);
                    }
                    externalExists = true;
                    modalDisplay.externalModal(jqMosaicItem);
                }
            }
        }

        function callSlick() {
            $('.modal .interactive-mosaic-item__content-list').slick({
                slidesToShow: 1,
                dots: true,
                arrows: false
            });
        }

        /**
         * Initialise modal window
         */
        callModal();

        /**
         * Initialise slick carousel for content items in interactive mosaic overlay
         */

        callSlick();

        // debouncing the modal window
        $(window).on('resize', debounce(function () {
            callModal();
            callSlick();
        }, 500));
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/interactive-mosaic.js
// module id = 189
// module chunks = 0